<template>
	<div class="flex flex_column flex_1">
		<AccessRestrictedTabs class="table_tabs"
							v-model="activeTab"
							:elements="tabTypes"
							:session-key="$route.path"
		/>
		<CompanyData v-if="activeTab === tabTypes.companyData"></CompanyData>
		<PutOptionSetting v-if="activeTab === tabTypes.putOptionSetting"></PutOptionSetting>
		<CofaceAGB v-if="activeTab === tabTypes.cofaceTos"/>
    	<TCIActivation v-if="activeTab === tabTypes.tciActivation"/>
	</div>
</template>

<script>

import CompanyData from "@/views/user/company/CompanyData";
import AccessRestrictedTabs from "@/components/templates/common/permissions/AccessRestrictedTabs";
import {enumDef} from "@/common/enumDefs";
import PutOptionSetting from "@/views/user/company/PutOptionSetting";
import CofaceAGB from "@/views/user/company/CofaceAGB";
import {navigationTabs} from "@/common/navigation/navigationTabs";
import TCIActivation from "@/views/user/company/TCIActivation";

export default {
  components: {
		PutOptionSetting,
		CompanyData,
		CofaceAGB,
		AccessRestrictedTabs,
    	TCIActivation
  },
  data() {
	  let tabTypes = {
			companyData: {
				name: navigationTabs.admin.company.info,
				translationKey: "company.tab.companyData",
				permission: enumDef.permissions.AdminCompany
			},
			cofaceTos: {
				name: navigationTabs.admin.company.cofaceToS,
				translationKey: "company.tab.cofaceAGB",
				permission: enumDef.permissions.AdminCompany
			},
			tciActivation: {
				name: navigationTabs.admin.company.tciActivation,
				translationKey: "company.tab.tciActivation",
				permission: enumDef.permissions.AdminCompany
			}
	  };
    return {
		tabTypes: tabTypes,
		activeTab: null,
    };
  },
};
</script>